// A rough gate against typos, not an RFC implementation: one @, no spaces, a dot in the
// domain. Deliverability is only ever proven by the mail actually arriving, so anything
// stricter here would reject valid addresses without buying certainty.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => EMAIL_REGEX.test(value || "");
